// extracted by mini-css-extract-plugin
module.exports = {"w1h7524q":"w1h7524q"};